import { render, staticRenderFns } from "./PendencyApprovedData.vue?vue&type=template&id=106100c0"
import script from "./PendencyApprovedData.vue?vue&type=script&lang=js"
export * from "./PendencyApprovedData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports